import React from 'react'
import error_404 from "../assets/image/404.svg"

export default function ErrorPage() {
    document.title = "Portfolio - 404 Error"
    return (
        <div className='error_404'>
            <img src={error_404} alt="404.svg" />
            <h1>404 - Page Not Found</h1>
            <p>Sorry, the page you are looking for does not exist.</p>
        </div>
    )
}
